import React from 'react';
import NavItems from './nav-items';

class Burger extends React.Component {

    constructor(props) {
        super(props);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.state = {
          menuActive: false,
          menuClass: 'hidden'
        };
      }
    
      toggleMenu() {
        let menuState = !this.state.menuActive;
        this.setState({
          menuActive: menuState,
          menuClass: menuState ? 'active' : 'hidden'
        });
      }

      handleChildClick() {
        this.setState({menuClass: 'hidden', menuActive: false});
      }
    
      render() {
        let menu;
        if(this.state.menuActive) {
          menu = <div className="mobile-drop">
                    <ul>
                      <NavItems closeMenu={this.handleChildClick.bind(this)}/>
                    </ul>
                  </div>
        } else {
          menu = "";
        }
        return ( 
          <div id = "menu">
            <a className={this.state.menuClass} id="nav-toggle" onClick = { this.toggleMenu }><span></span></a>
            {menu} 
        </div>
        )
      }
  }

export default Burger


// WEBPACK FOOTER //
// ./src/shared/burger.js